import React from "react";

const CPP_Data_Types = () => {
  return (
    <div>
      <h1>CPP_Data_Types Component</h1>
      <p>Content for CPP_Data_Types goes here...</p>
    </div>
  );
};

export default CPP_Data_Types;
